import $ from 'jquery';

class Feedback {
    constructor(){
     this.events();
    }

    events(){
        $(".delete-note").on("click", this.deleteFeedback);
        
    }
    //Methods will go here
    deleteFeedback () {
        //alert("You've clicked delete")
         $.ajax();
    }
}
export default Feedback;